import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'react-native-paper';
import { t } from '@lingui/macro';
// @ts-ignore
import countryTelephoneCode from 'country-telephone-code';
import emojiFlags from 'emoji-flags';

import useActionSheets from '@src/hooks/useActionSheets';
import { i18n } from '@src/i18n';

type Props = {
  name: string;
};

const options = emojiFlags.codes.map(
  (name, index) =>
    `${emojiFlags.emojis[index]} (+${countryTelephoneCode(name)}) ${name}`
);

const Component: React.FC<Props> = ({ name }) => {
  const actionSheets = useActionSheets();
  const { register, unregister, setValue } = useFormContext();
  const [selected, setSelected] = React.useState(108); // 108 is iran :)

  React.useEffect(() => {
    register(name);
    return () => unregister(name);
  }, [name, register, unregister]);

  React.useEffect(() => {
    setValue(name, emojiFlags.codes[selected]);
  }, [name, selected, setValue]);

  const handleRegionPress = React.useCallback(() => {
    actionSheets(
      {
        options,
        message: i18n._(t`Change Region`),
        destructiveButtonIndex: selected,
        cancelButtonIndex: selected,
      },
      (key) => {
        if (key !== undefined) {
          setSelected(key);
        }
      }
    );
  }, [actionSheets, selected]);

  const code = emojiFlags.codes[selected];
  return (
    <Button compact onPress={handleRegionPress}>
      {`${emojiFlags.emojis[selected]} (+${countryTelephoneCode(code)}) `}
    </Button>
  );
};

Component.displayName = 'RegionInput';

export default Component;
